var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-date-tag",style:({
    '--tag-dot-color': _vm.tagColor.dotColor,
    '--tag-back-color': _vm.tagColor.backColor,
    '--tag-text-color': _vm.tagColor.textColor,
  }),attrs:{"data-deliver-part":"deliver-code"}},[_c('div',{staticClass:"ot-date-tag__dot"}),_vm._v(" "+_vm._s(_vm.dateFormatted)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }